import CustomTable from "../../../../../components/table/CustomTable"
import { NotificationChannelsTableApp } from "../Functionality/NotificationChannelsTableApp"

/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */

const NotificationChannelsTable = ({ item, handleChange, disabled }) => {

    const {
        tableId,
        searchId,
        thead,
        tbody
    } = NotificationChannelsTableApp({ item, handleChange, disabled })

    return (
        <>
            <CustomTable
                tableId={tableId}
                searchId={searchId}
                thead={thead}
                tbody={tbody}
                columnActions={false}
                withoutHeight={true}
            />
        </>
    )
}

export default NotificationChannelsTable
